export enum IpVersion {
  V4 = 1,
  V6,
  AnyOne
}
